import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {VetClinic} from "../vet-clinic.model";

export class VetClinicDgSearchResults extends GenericDgSearchResults {
  public results: VetClinic[];

  constructor(total: number, results: VetClinic[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

